


import Vue from 'vue';
import { mapState } from 'vuex';

export default Vue.extend({
  computed: {
    ...mapState('app', ['categories'])
  },

  watch: {
    categories: {
      immediate: true,
      handler() {
        this.redirectToDefaultCategory();
      }
    }
  },

  mounted() {
    this.redirectToDefaultCategory();
  },

  methods: {
    redirectToDefaultCategory() {
      if (!this.categories.length) return;
      this.$router.push(`/${this.categories[0].id}`);
    }
  }
});
